module.exports = __webpack_public_path__ + "media/images/lb/733-f8c5c4b29ceec6a19f9b4adae53f3159.svg";